import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import {
  Application,
  getApplication,
  GetApplicationArgs
} from './requests/get-application'

export function useApplication(
  organizationUuid: string,
  applicationId: string,
  enabled: boolean = true
) {
  return useContrastQuery<GetApplicationArgs, Application>(
    [Query.APPLICATION, organizationUuid, applicationId],
    getApplication,
    {
      organizationUuid,
      applicationId
    },
    { enabled }
  )
}
